export default "__VITE_ASSET__54a0944b__"